import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Secure from '../views/Secure.vue'
import store from '../store'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },


  {
    path: '/join',
    name: 'joinworkspace',
    component: () => import('../views/Workspace/Joinworkspace.vue'),
    meta: {
      requiresAuth: true,
    }
  },

  {
    path: '/secure',
    name: 'secure',
    component: Secure,
    meta: {
      requiresAuth: true,
    }
  },

  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  },

  {
    path: '/account/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },

  {
    path: '/account/signup',
    name: 'signup',
    component: () => import('../views/Signup.vue')
  },

  {
    path: '/honey',
    name: 'honey',
    component: () => import('../views/Honeypot.vue')
  },

  {
    path: '/account/account-recovery',
    name: 'accountrecovery',
    component: () => import('../views/ForgotPassword.vue')
  },

  {
    path: '/account/account-reset/:resetslug',
    name: 'accountreset',
    component: () => import('../views/ValidatePassword.vue')
  },

  {
    path: '/account/account-reset-succcess',
    name: 'accountresetsuccess',
    component: () => import('../views/ValidatePasswordSuccessful.vue')
  },

// ___________________________ WORKSPACE RELATED FUNCTIONS
  {
    path: '/:slug',
    name: 'workspaceview',
    redirect: { name: 'issues' },
    component: () => import('../views/Workspace/WorkspaceView.vue'),
    meta: {
      requiresAuth: true,
    },

    children: [
      {
        path: 'welcome',
        name: 'welcome',
        components:{
          default: () => import('../views/Welcome.vue'),
        }
      },

      {
        path: 'settings/account/',
        name: 'settings',
        components: {
          main: () => import('../views/Workspace/Settings.vue')
        }
      },

      {
        path: 'settings/account/profile',
        name: 'profile',
        components: {
          main: () => import('../views/Workspace/Profile.vue')
        }
      },

      {
        path: 'my-issues/assigned',
        name: 'issuesassigned',
        components: {
          main: () => import('../views/Workspace/Issues/MyIssuesAssigned.vue'),
        }
      },

      {
        path: 'my-issues/created',
        name: 'issuescreated',
        components: {
          main: () => import('../views/Workspace/Issues/MyIssuesCreated.vue'),
        }
      },

      {
        path: 'team/active',
        name: 'issues',
        components: {
          main: () => import('../views/Workspace/Issues/Issue.vue'),
        }
      },

      {
        path: 'team/backlog',
        name: 'backlog',
        components: {
          main: () => import('../views/Workspace/Issues/Backlog.vue'),
        }
      },

      {
        path: 'team/all',
        name: 'all',
        components: {
          main: () => import('../views/Workspace/Issues/All.vue'),
        }
      },

      {
        path: 'team/board',
        name: 'board',
        components: {
          main: () => import('../views/Workspace/Issues/Board.vue'),
        }
      },

      {
        path: 'team/new',
        name: 'newissue',
        components: {
          main: () => import('../views/Workspace/Issues/IssueNew.vue'),
        }
      },

      {
        path: 'issue/edit/:issueslug',
        name: 'editissue',
        components: {
          main: () => import('../views/Workspace/Issues/IssueEdit.vue'),
        }
      },


      {
        path: 'issue/:issueslug',
        name: 'issuedetail',
        components: {
          main: () => import('../views/Workspace/Issues/IssueDetail.vue'),
        }
      },

      {
        path: 'project/:projectslug',
        name: 'projectbase',
        components: {
          main: () => import('../views/Workspace/Projects/ProjectBase.vue'),
        }
      },

      {
        path: 'team/projects/active?new=true',
        name: 'newproject',
        components: {
          main: () => import('../views/Workspace/Projects/NewProject.vue'),
        }
      },

      {
        path: 'team/projects/active',
        name: 'projects',
        components: {
          main: () => import('../views/Workspace/Projects/Project.vue'),
        }
      },

    ]
  },
  // ___________________________ WORKSPACE RELATED FUNCTIONS

  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue')
  },

  {
    path: '/error-ws',
    name: '404ws',
    component: () => import('../views/404ws.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const userPreventAccessIfLoggedIn = ['login', 'signup']
  const loggedIn = store.getters['auth/isLoggedIn'];
  // const hasWorkspace = store.getters['auth/workspaces'];

  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (loggedIn) {
      next()
      return
    }
    localStorage.setItem('loginContinue', to.fullPath)
    next('/login')
  } else if (userPreventAccessIfLoggedIn.includes(to.name) && loggedIn) {
  // } else if ((to.name === "login" || to.name === "signup") && loggedIn) {
      return next({path: '/'})
  }
  else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})


export default router
